import {useQuery} from '@tanstack/react-query'
import {followUpService} from '../services/FollowUpService'
import {followUpKeys} from './query-keys'
import type {FollowUpFilialResponse, FollowUpItemOrdemCompraResponse, FollowUpOrdemCompraResponse} from '../types'

interface ParametrosItensOrdemCompraQuery {
  idOrdemCompra: number | null;
}

interface ParametrosFilialOrdemCompraQuery {
  idOrdemCompra: number | null;
}

export function useFollowUpOrdensCompraQuery() {
  return useQuery<FollowUpOrdemCompraResponse[]>({
    queryKey: followUpKeys.ordensCompra(),
    queryFn: async () => {
      const {data} = await followUpService.getOrdensCompra()
      return data
    },
  })
}

export function useFollowUpItensOrdemCompraQuery({idOrdemCompra}: ParametrosItensOrdemCompraQuery) {
  const hasParametros = idOrdemCompra !== null

  return useQuery<FollowUpItemOrdemCompraResponse[]>({
    queryKey: followUpKeys.itens(idOrdemCompra ?? ''),
    queryFn: async () => {
      if (!hasParametros) return []

      const {data} = await followUpService.getItensOrdemCompra({idOrdemCompra})
      return data
    },
    enabled: hasParametros,
  })
}

export function useFollowUpFilialOrdemCompraQuery({idOrdemCompra}: ParametrosFilialOrdemCompraQuery) {
  const hasParametros = idOrdemCompra !== null

  return useQuery<FollowUpFilialResponse | null>({
    queryKey: followUpKeys.filial(idOrdemCompra ?? ''),
    queryFn: async () => {
      if (!hasParametros) return null

      const {data} = await followUpService.getFilialOrdemCompra(idOrdemCompra)
      return data
    },
    enabled: hasParametros,
  })
}
